'use strict';

Dropzone.autoDiscover = false;
import 'dropzone';

const validation = {
  settings: {
    token: $('meta[name="csrf-token"]').attr('content'),
  },
  dropzone() {
    new Dropzone('#myDropzone', {
      url: `${window.location.origin}/minha-equipe/validacao-de-acao`,
      paramName: 'document',
      maxFilesize: 10,
      maxFiles: 50,
      params: {
        _token: s.token,
      },
      addRemoveLinks: true,
      dictDefaultMessage: 'Selecione os arquivos que deseja enviar',
      dictCancelUpload: 'Cancelar o envio',
      dictRemoveFile: 'Remover',
      dictMaxFilesExceeded: 'Você alcançou o limite de arquivos',
      dictFileTooBig: 'Arquivo muito grande',
      dictInvalidFileType: 'Este arquivo não é válido',
      init: function() {
        this.on('success', function(file, response) {
          $('.added_documents').append('<input type="hidden" data-name="' + file.name + '" name="document[]" value="' + response + '"/>');
        });
      },
    });
  },

  init() {
    _this.dropzone();
  },
};

const _this = validation,
  s = _this.settings;

export default validation;
